/* global process */
import React from 'react';
import PropTypes from 'prop-types';

import styles from './QuestionRubricBlockDisplay.scss';

class QuestionRubricBlockDisplay extends React.PureComponent {
    componentDidMount() {
        this.props.onReady(true);
    }

    componentDidUpdate() {
        this.props.onReady(true);
    }

    render() {
        const { model } = this.props;
        return (
            <div className={styles.rubricBlock} dangerouslySetInnerHTML={{ __html: model.rubricBlockContent }} />
        );
    }
}

QuestionRubricBlockDisplay.propTypes = {
    onReady: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
};

export default QuestionRubricBlockDisplay;
